<!-- 需方项目对应路由的总页面 -->
<template>
  <div class="app-wrapper">
    <div class="main-container">
      <div>
        <navbar />
      </div>
      <div class="container-box">
        <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
        <sidebar v-if="showSiderBar" :class="{'sidebar-container':true,'sidebar-container-hide':isZd}" @zd="zd" />
        <content class="content">
          <!-- <TagsView /> -->
          <app-main />
          <rightNav ref="rightNav" />
        </content>
        <div v-show="isZd" class="btn-zk" @click="isZd=false">
          展<br>开<br>&gt;</div>
      </div>
      <div v-if="showFooter">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, Footer } from './components'
// import ResizeMixin from './mixin/ResizeHandler'
import rightNav from '../components/rightNav.vue'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Footer,
    rightNav
    // TagsView
  },
  data() {
    return {
      isZd: false
    }
  },
  // mixins: [ResizeMixin],
  computed: {
    showFooter() {
      // return this.$store.state.app.showFooter
      return this.$route.meta.showFooter
    },
    showSiderBar() {
      // return this.$store.state.app.showSiderBar
      return this.$route.meta.showSiderBar
    }
  },
  watch: {
    // $route() {
    //   console.log(this.$route)
    //   this.$store.commit('app/SET_FOOTER', this.$route.meta.showFooter)
    //   this.$store.commit('app/SET_SIDERBAR', this.$route.meta.showSiderBar)
    // }
    // showFooter(val) {
    //   console.log('footer', val)
    // },
    // showSiderBar(val) {
    //   console.log('siderbar', val)
    // }
  },
  /**
   * 页面创建前
   */
  beforeCreate() {
    // 暂时修改fhd
    // document.querySelectorss('body').setAttribute('style', 'overflow-y:hidden;background-color:#F5F5F5;')
    document.querySelector('body').setAttribute('style', 'background-color:#F5F5F5;')
  },
  /**
   * 页面销毁前
   */
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    // handleClickOutside() {
    //   this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    // }
    zd() {
      console.log('折叠')
      this.isZd = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .container-box{
    height: 100%;
    display: flex;
    padding: 0px 75px 0 50px;
    background-color: #F5F5F5;
    overflow-y: hidden;
    box-sizing: border-box;
    flex: 1;
  }
  .content{
    display: flex;
    width: 100%;
    // height: 100%;
    overflow: hidden;
    flex: 1;
    // background-color: #F1F1F1;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  // .fixed-header {
  //   position: fixed;
  //   top: 0;
  //   right: 0;
  //   z-index: 9;
  //   width: calc(100% - #{$sideBarWidth});
  //   transition: width 0.28s;
  // }

  // .hideSidebar .fixed-header {
  //   width: calc(100% - 54px)
  // }

  // .mobile .fixed-header {
  //   width: 100%;
  // }
  #app .sidebar-container-hide{
    min-width: 0 !important;
    width: 0 !important;
  }
  .btn-zk{
  position: absolute;
  top:326px;
  font-size: 12px;
  left: 0;
  transform: translateY(-50%);
  font-family: monospace;
  width: 32px;
  background: #E9E9E9;
  padding: 10px 0;
  line-height: 18px;
  user-select: none;
  cursor: pointer;
  z-index: 9;
  text-align: center;
}
</style>
